<template>
    <div class="platInfer">
        <div id="container" class="container">
            <div class="tileGeneration">
                <el-form :inline="true" :model="formparam">
                    <el-form-item :label="$t('text.Architecture')">
                        <el-select
                            v-model="formparamStr"
                            :placeholder="$t('placeholderText.SelectArchitecture')"
                            :title="formparamStr"
                            filterable
                            :filter-method="filterData"
                            @visible-change="visibleChange"
                        >
                            <el-option :value="formparam.id" style="height: auto">
                                <section class="alltree">
                                    <trees class="mytree" ref="tree" :treedata="mapTree" highlight-current :nodeKey="nodeKey" @changeNode="nodeClick" />
                                </section>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-button icon="el-icon-search" type="primary" @click="mapLookUp" :title="$t('buttonTitle.Inquiresearch')"></el-button>
                    <el-button icon="el-icon-refresh" type="primary" @click="refresh" :title="$t('buttonTitle.Refresh')"></el-button>
                </el-form>
                <div class="refurbish">
                    <span>{{ $t('text.Refresh Interval (Minutes)') }}：{{ minutes }}</span>
                    <div class="interval" @mouseup="mouseup">
                        <el-slider v-model="minutes" :min="minnum" :max="maxnum" @change="flush"></el-slider>
                    </div>
                </div>
            </div>
            <!-- 详细框 -->
            <section class="ponitDetail" :class="active ? 'active' : ''">
                <section class="close"><span @click="handleClose">X</span></section>
                <section class="message">
                    <div class="m_car">
                        <section>
                            <img
                                :src="require(`@/assets/images/img/cs${personinfo.type}.png`)"
                                alt=""
                                srcset=""
                                :title="personinfo.type == 1 ? '' + $t('text.Vehicle') + '' : '' + $t('text.Architecture') + ''"
                            />
                            <span style="color: #000">{{ personinfo.name }}</span>
                        </section>
                        <img :src="require('@/assets/images/img/point1.png')" alt="" srcset="" :title="$t('text.location')" v-if="personinfo.type == 1 ? true : false" @click="historicalMap" />
                    </div>
                    <div class="m_m">
                        <p :title="titleP" v-if="personinfo.type == 1 ? true : false">{{ $t('text.address') }}:{{ personinfo.sceneNamePath ? personinfo.sceneNamePath : '--' }}</p>
                        <p>{{ $t('labelTitle.Status') }}:</p>
                        <p>{{ $t('labelTitle.UpdateTime') }}:{{ $timetransition(personinfo.time) }}</p>
                        <p :title="personinfo.address">{{ $t('labelTitle.current_location') }}:{{ personinfo.address }}</p>
                    </div>
                </section>
                <!-- type==1 -->
                <template v-if="personinfo.type == 1">
                    <section class="detail">
                        <div class="d_top">
                            <img :src="require('@/assets/images/img/SENCE.png')" alt="" />
                            <span>{{ $t('labelTitle.Sensor') }}</span>
                        </div>
                        <div class="d_list">
                            <section v-for="(item, index) in carArray" :key="index">
                                <span style="color: #000">{{ item.sensorCode }}</span>
                                <span style="color: #000">({{ item.tempDat ? item.tempDat + '℃' : '' }} {{ item.lightDat ? item.lightDat + '%' : '' }})</span>
                                <img :src="require('@/assets/images/img/metiam.png')" @click="realTimeData(item)" :title="$t('tableTitle.real-time_data')" alt="" style="margin-left: 55px;" />
                                <img :src="require('@/assets/images/img/TIME.png')" @click="historicalData(item)" :title="$t('tableTitle.historical_data')" alt="" />
                            </section>
                        </div>
                    </section>
                </template>

                <section v-else class="detailscence">
                    <span>{{ $t('text.Node_ontent') }}:</span>
                    <tree-node :sublevelTree="sublevelTree"></tree-node>
                </section>
            </section>
        </div>
    </div>
</template>

<script>
import { mapNode, mapSpwtime, detailcsd } from '@/api/monitoring';
import { rolerighttree, mpDetailFn } from '@/api/api';
import { getLanguage } from '@/lang';
// import infowindow from './children/infowindow'
import Image1 from '../../assets/images/img/green_dence.png';
import Image2 from '../../assets/images/img/red_car.png';
import Image3 from '../../assets/images/img/red_cense.png';
import Image4 from '../../assets/images/img/green_car.png';
import Image5 from './markera.png';
import TreeNode from './children/treeNode.vue';

export default {
    name: 'mapDetail',
    inject: ['reload'],
    components: {
        // 'v-information': infowindow,
        TreeNode
    },
    data() {
        return {
            data: [],
            defaultProps1: {
                children: 'children',
                label: 'label'
            },
            titleP: '南沙疾控 /广州市南沙区疾控 /第一人民医院南沙医院/3楼产科接种点',
            nodeKey: 'id',
            carArray: [],
            endIcon: '',
            map: undefined,
            minutes: null,
            minnum: 1,
            maxnum: 60,
            timing: 2000,
            center: [],
            markerList: [],
            iswindow: false,
            distance: false,
            personinfo: {
                type: 0
            },
            nodesCsd: [],
            postion: [],
            sublevelTree: {},
            mapis: false,
            mapTree: [],
            findList: [],
            contentNodes: {
                text: ''
            },
            defaultProps: {
                label: 'text',
                children: 'item'
            },
            nodal: '',
            intervalId: null, //做一个定时器
            formparam: {
                id: ''
            },
            formparamStr: '',
            active: false
        };
    },
    created() {
        setTimeout(() => {
            this.init();
            this.addMarker();
        }, 500); //参数是函数名
    },
    mounted() {
        this.getMaplist();
    },
    destroyed() {
        // 在页面销毁后，清除计时器
        this.clear();
    },
    methods: {
        // 树形过滤方法
        // filterData(e) {
        //   this.treeList = this.$treeText(e, this.treeList)
        // },
        visibleChange(val) {
            if (val) {
                this.mapTree = this.$store.getters.SchemaTree;
            }
        },
        filterData(e) {
            if (!e) {
                this.mapTree = this.$store.getters.SchemaTree;
            } else {
                this.mapTree = this.$treeText(e, this.mapTree);
            }
        },
        // 关闭弹窗
        handleClose() {
            this.active = false;
        },
        // 轨迹
        historicalMap() {
            let { href } = this.$router.resolve({
                path: '/pastdatumHome',
                query: { data: JSON.stringify(this.personinfo) }
            });
            let title = this.personinfo.name;
            let obj = window.open(href, title, 'height=800,width=1440,top=100,left=200,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no');
            obj.document.title = title;
            obj.onload = function() {
                // 定时器根据实际情况取舍。
                setTimeout(() => {
                    obj.document.title = title;
                }, 100);
            };
        },
        //实时数据
        realTimeData(arg) {
            let obj = JSON.stringify({
                tag: arg.sensorCode,
                type: arg.type,
                sensor_id: arg.sensorId,
                interval: arg.interval ? arg.interval : ''
            });
            let routeurl = this.$router.resolve({
                path: '/realtime',
                query: { param: obj }
            });
            window.open(routeurl.href, '_blank');
        },
        // 历史数据
        historicalData(arg) {
            let obj = JSON.stringify({
                tag_id: arg.sensorCode,
                type: arg.type,
                sensor_id: arg.sensorId
            });
            let routeData = this.$router.resolve({
                path: '/historyData',
                query: { param: obj }
            });
            window.open(routeData.href, '_blank');
            // let routeurl = this.$router.resolve({
            //   path: '/historyData',
            //   query: { id: { text: arg.sensorCode,type:arg.type } },
            // })

            // window.open(routeurl.href, '_blank')
        },

        getMaplist() {
            let tid = {
                type: 1,
                loadCarrier: true,
                loadSensor: false,
                userId: this.$store.getters.userInfo.user.id
            };
            rolerighttree(tid).then(res => {
                this.mapTree = res.result.item;
                this.findList = res.result.item;
            });

            mapSpwtime().then(res => {
                this.$nextTick(() => {
                    this.minutes = JSON.parse(localStorage.getItem('time')) || Math.floor(res.result / 60); //向下取整
                    this.timing = this.minutes * 60 * 1000;
                    this.dispatcherTimer(this.timing);
                });
            });
            mapNode().then(res => {
                // 获取地图节点数据
                this.$nextTick(() => {
                    this.nodesCsd = res.result;
                });
            });
        },
        refresh() {
            // this.init()
            // this.addMarker()
            // this.getMaplist()
            this.reload();
        },
        // reset() {
        //   this.mapTree = this.findList
        //   this.formparamStr = ''
        // },
        mapLookUp() {
            if (this.postion.length != 0) {
                this.map.setZoomAndCenter(16, this.$wgs84togcj02(this.postion[0].longitude, this.postion[0].latitude));
            } else {
                this.$message.warning(this.$t('public.btn_noData'));
            }
            // this.mapTree = this.treeNode(this.nodal, this.mapTree)
        },
        treeFn(arg, arr, listTree = []) {
            if (arg.label.nodeType == 2) {
                arr.filter(item => {
                    if (item.id === arg.label.id) {
                        listTree.push(item);
                        // console.log(listTree);
                    } else {
                        this.treeFn(arg, item.item, listTree);
                    }
                });
                // console.log(listTree);
                return listTree;
            }
        },
        nodeClick(val) {
            // if (val.label.nodeType == 2) {
            //   this.mapTree = this.treeFn(val, this.findList)
            // }
            // console.log(this.mapTree);
            let mapobj = this.nodesCsd;
            if (val.label.nodeType == 2) {
                this.postion = mapobj.filter(item => {
                    if (item.id == val.label.scene_id) {
                        return item;
                    }
                });
            } else {
                this.postion = mapobj.filter(item => {
                    if (item.id == val.label.carrier_id) {
                        return item;
                    }
                });
            }
            let arr = this.$getParent(this.mapTree, val.label.id).map(item => {
                return item.label;
            });
            this.formparamStr = arr.join(',').replace(/,/g, ' / ');
            // if (val.label.scene_id == 'all') {
            //   this.formparam.id = '0'
            // } else {
            //   this.formparam.id = val.label.scene_id
            // }
        },

        treeNode(val, treeData) {
            if (val == '') return this.findList;
            let list = [];
            let convert = arr => {
                arr.filter(items => {
                    if (items.label.indexOf(val) > -1) {
                        list.push(items);
                    } else {
                        if (items.item) {
                            return convert(items.item);
                        }
                    }
                });
            };
            convert(treeData);
            return list;
        },

        getsearch(val, type) {
            if (type == 0) {
                mpDetailFn({ id: val }).then(res => {
                    this.sublevelTree = res.result;
                });
            } else if (type == 1) {
                //车辆
                detailcsd({ id: val }).then(res => {
                    this.carArray = res.result;
                });
            }
        },

        // toolsCli() {
        //   this.distance = !this.distance
        // },

        //定时器
        dispatcherTimer(time) {
            if (this.intervalId != null) {
                return;
            }
            this.intervalId = setInterval(() => {
                this.reload();
            }, time);
        },
        // 停止定时器
        clear() {
            clearInterval(this.intervalId); //清除计时器
            this.intervalId = null; //设置为null
        },
        mouseup() {
            this.$message.success($t('integration.set_successfully'));
        },
        // 进度条
        flush(val) {
            this.clear();
            this.timing = val * 60 * 1000;
            localStorage.setItem('time', val);
            this.dispatcherTimer(this.timing);
            this.minutes = val;
            return val / 100;
        },

        //初始化map对象
        init: function() {
            // [AMap removed] let map = new AMap.Map('container', {
            //     center: [113.428878, 23.169201],
            //     // pitch: 0, // 视角角度，有效范围 0 度 - 83 度
            //     resizeEnable: true, //是否监控地图容器尺寸变化
            //     viewMode: '3D',
            //     zoom: 4,
            //     buildingAnimation: true,
            //     lang: getLanguage().split('_')[0],
            //     showRoad: true
            //     // mapStyle: 'amap://styles/577e843984551368f30118996762aa0c',
            // });
            // [AMap removed] AMap.plugin(['AMap.ToolBar', 'AMap.Scale', 'AMap.ControlBar'], function() {
            //     map.addControl(new AMap.Scale());
            //     // map.addControl(new AMap.ToolBar())
            //     var controlBar = new AMap.ControlBar({
            //         position: {
            //             right: '2%',
            //             bottom: '-10%'
            //         }
            //     });
            //     map.addControl(controlBar);
            // });
            // [AMap removed] this.map = map;
        },
        //添加marker
        addMarker() {
            let mapobj = this.nodesCsd;
            let that = this;
            let imageb = Image5;

            that.$nextTick(function() {
                //循环遍历每一个坐标地点   显示在界面上  判断显示不同的图标
                if (mapobj.length != 0) {
                    for (let i = 0; i < mapobj.length; i++) {
                        if (mapobj[i].ex === 0 && mapobj[i].type === 0) {
                            imageb = Image1;
                        } else if (mapobj[i].ex === 1 && mapobj[i].type === 1) {
                            imageb = Image2;
                        } else if (mapobj[i].ex === 1 && mapobj[i].type === 0) {
                            imageb = Image3;
                        } else if (mapobj[i].ex === 0 && mapobj[i].type === 1) {
                            imageb = Image4;
                        }
                        // [AMap removed] const startIcon = new AMap.Icon({
                        //     image: imageb,
                        //     imageSize: new AMap.Size(32, 32)
                        // });
                        // [AMap removed] let marker = new AMap.Marker({
                        //     // position: this.$wgs84togcj02(
                        //     //   mapobj[i].longitude,
                        //     //   mapobj[i].latitude
                        //     // ), // 地图坐标
                        //     position: [mapobj[i].longitude, mapobj[i].latitude],
                        //     title: mapobj[i].name,
                        //     icon: startIcon
                        // });

                        // 弹窗内容 引用组件优化写法?
                        // marker.content = that.$refs.information.$el

                        //绑定点击事件
                        marker.on('click', positionResult => {
                            that.active = true;
                            // 在这里获取经纬度传递给后端发起请求获取返回的数据
                            that.getsearch(mapobj[i].id, mapobj[i].type); //点击地图的坐标信息获取id发起请求

                            that.setZoomFn(mapobj[i]);
                            that.GeocoderFn(mapobj[i]).then(res => {
                                that.personinfo = Object.assign({}, mapobj[i], { address: res });
                            });
                        });

                        marker.setLabel({
                            // [AMap removed] offset: new AMap.Pixel(18, 20), //设置文本标注偏移量
                            content: mapobj[i].name, //设置文本标注内容
                            direction: 'right' //设置文本标注方位
                        });
                        that.markerList.push(marker);
                        that.map.add(that.markerList);
                    }
                }
            });
        },
        // 放大
        setZoomFn(obj, zoom = 16) {
            const mapMaker = [obj.longitude, obj.latitude];
            this.map.setZoomAndCenter(zoom, mapMaker);
        },
        // 转经纬度
        GeocoderFn(obj) {
            return new Promise((resolve, reject) => {
                // [AMap removed] var lnglatXY = new AMap.LngLat(obj.longitude, obj.latitude);
                let MGeocoder,
                    address = '';
                // [AMap removed] AMap.plugin(['AMap.Geocoder'], function() {
                //     MGeocoder = new AMap.Geocoder({
                //         radius: 1000,
                //         extensions: 'all'
                //     });
                //     //根据经纬度获取地址
                //     AMap.event.addListener(MGeocoder, 'complete', res => {
                //         address = res.regeocode.formattedAddress;
                //         resolve(address);
                //     });
                //
                //     //逆地理编码
                //     MGeocoder.getAddress(lnglatXY);
                // [AMap removed] });
            });
        },
        switchover() {
            this.mapis = !this.mapis;
            this.getMaplist();
        }
    }
};
</script>

<style lang="scss" scoped>
@import '@/styles/tree.scss';
.el-select-dropdown__item {
    padding: 0;
}
.custom-content-marker {
    position: relative;
    width: 25px;
    height: 34px;
}

.custom-content-marker img {
    width: 100%;
    height: 100%;
}

/* [AMap removed] .amap-demo {
    position: fixed;
    width: 100%;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
} */

/* [AMap removed] ::v-deep.amap-icon {
    width: 32px !important;
} */

// 设置点标注的标签文本内容样式
/* [AMap removed] ::v-deep.amap-marker-label {
    top: -20px !important;
    left: -4px !important;
    border: none;
    background: rgba(255, 255, 255, 0);
    font-size: 16px;
    font-weight: 600;
    color: var(--primary-color);
} */
.platInfer {
    height: 100%;
    border: 1px solid #fcfcfc;
    box-sizing: border-box;
    .container {
        height: 100%;
        /* [AMap removed] ::v-deep.amap-marker-label {
            background-color: transparent;
            border: none;
        } */
    }
    position: relative;
    .ponitDetail {
        position: absolute;
        width: 355px;
        height: 100%;
        padding: 20px;
        margin: 0;
        box-sizing: border-box;
        left: -355px;
        top: 85px;
        transition: all 1s;
        z-index: 999;
        background: #ffffff;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        display: flex;
        flex-direction: column;
        .close {
            height: 4%;
            text-align: right;
            box-sizing: border-box;
            border-bottom: 1px solid #f3f3f3;
            span {
                cursor: pointer;
                width: 20px;
                height: 100%;
                line-height: 23px;
                text-align: center;
                display: inline-block;
                &:hover {
                    background-color: var(--primary-color);
                    color: #fff;
                }
            }
        }
        .message {
            margin-top: 0px;
            height: 30%;
            .m_car {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 5%;
                box-sizing: border-box;
                height: 30%;
                section {
                    width: 70%;
                    span {
                        margin-left: 5%;
                        font-size: 18px;
                        font-weight: 400px;
                        vertical-align: middle;
                    }
                }
            }
            .m_m {
                padding-left: 10%;
                box-sizing: border-box;
                border-bottom: 1px solid #f3f3f3;
                p {
                    width: 90%;
                    height: 40px;
                    line-height: 40px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    color: rgba(56, 56, 56, 0.5);
                }
            }
        }
        .detail {
            padding-left: 5%;
            height: 50%;
            .d_top {
                height: 10%;
                span {
                    font-size: 18px;
                    margin-left: 5%;
                    vertical-align: middle;
                    font-weight: 400;
                }
            }
            .d_list {
                height: 90%;
                overflow: auto;
                display: flex;
                flex-direction: column;
                section {
                    height: 10%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }
                .Car_img {
                    img {
                        margin-right: 5px;
                    }
                }
            }
        }
        .detailscence {
            padding-left: 7%;
            height: 56%;
            span {
                font-size: 18px;
                font-weight: 400;
            }
        }
        img {
            display: inline-block;
            width: 28px;
            height: 28px;
            cursor: pointer;
        }
    }
    .active {
        left: 0;
    }
    .tileGeneration {
        height: 80px;
        position: absolute;
        top: 0px;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 22px 15px;
        margin: 0 10px;
        box-sizing: border-box;
        z-index: 999;
        background: rgba(255, 255, 255, 0.5);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-radius: 5px;
        .second {
            margin-left: 186px;
        }
        > span {
            text-align: center;
            width: 27px;
            font-size: 22px;
            height: 34px;
            display: inline-block;
            color: #666;
            // border-left: 1px solid $border5;
            cursor: pointer;
            i:hover {
                color: $blue1;
            }
        }
        .btn_search {
            width: 180px;
            position: absolute;
            top: 0;
            height: 30px;
            border: none;
        }

        .mtree {
            position: absolute;
            top: 40px;
            height: auto;
            max-height: 350px;
            width: 21.875rem;
            overflow-x: scroll;
            border: 1px solid rgb(189, 176, 176);
        }
        ::v-deep.el-form-item__label {
            background-color: transparent;
        }
        ::v-deep.el-form-item__content {
            background-color: transparent;
        }
        ::v-deep.el-button--mini {
            width: 36px !important;
            min-width: 0 !important;
            margin-top: 0 !important;
        }
    }
    .refurbish {
        height: 60px;
        width: 300px;
        position: absolute;
        top: 6px;
        right: -40px;
        display: flex;
        align-items: center;
        .interval {
            width: 110px;
            margin-left: 20px;
        }
        ::v-deep.el-slider__runway {
            background-color: #fff;
        }
    }
}
.alltree {
    height: 200px;
    overflow: auto;
    width: 100%;
    max-width: 400px;
    .mytree {
        min-width: 100% !important;
        height: 10% !important;
        display: inline-block;
        ::v-deep.el-tree-node {
            padding-left: 0 !important;
        }
    }
}

.el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
    background-color: #fff;
}

.mainDialogLayout {
    display: flex;
}
.dialogForm .el-input--mini {
    width: 70%;
}

::v-deep.el-form-item--mini .el-form-item__label,
::v-deep.el-form-item--mini .el-form-item__content {
    background: rgba(255, 255, 255, 0);
}
</style>
